import API from 'API';

export const getMe = async () => API.find('users/me');

export const findUsers = async () => API.find(`users`);

export const findEnabledUsers = async () => API.find(`users/enabled`);

export const findAces = async (id) => API.find(`users/${id}/acls/`);

export const saveAce = async (ace) => API.save('acls/', ace);
